import { createApiClient } from '@/api/apiClient';

export const createDownloadFileHttpClient = (baseURL: string) => createApiClient({ baseURL }, true);
